import axios from "axios";
import { set, event } from 'vue-gtag';
import urls from "../../urls";

export default {
    namespaced: true,
    state: {
        'id': '',
        'username': '',
        'organizations': [
            // {
            //     "id": 1,
            //     "name": "HEAT",
            //     "users": [
            //         1,
            //         3,
            //     ]
            // }
        ],
        'isStaff': false,
        'hasTwoFactorDevices': false,
        'twoFactorDevices': [
            // {
            //     'id': 'sms:1',
            //     'name': 'Default',
            //     'type': 'sms'
            // }
        ]
    },
    mutations: {
        setUser(state, payload) {
            state.id = payload.id;
            state.username = payload.username;
            state.organizations = payload.organizations;
            state.isStaff = payload.is_staff || payload.isStaff;
            state.hasTwoFactorDevices = payload.hasTwoFactorDevices || payload.is_authenticated;
        },
        resetUser(state, payload) {
            state.id = '';
            state.username = '';
            state.organizations = [];
            state.isStaff = false;
            state.hasTwoFactorDevices = false;
        },
        setTwoFactorDevices(state, payload) {
            state.twoFactorDevices = payload.twoFactorDevices || payload;
            if (state.twoFactorDevices.length > 0) {
                state.hasTwoFactorDevices = true;
            }
        },
    },
    actions: {
        getUser(context) {
            return new Promise(async (resolve, reject) => {
                try {
                    if(typeof __INITIAL__STATE__ !== 'undefined'  && typeof __INITIAL__STATE__.account === 'object' && __INITIAL__STATE__.account != null) {
                        context.commit('setUser', __INITIAL__STATE__.account);
                        set("userId", context.state.id);
                        resolve();
                        return;
                    }
                    if (localStorage.getItem('Token')) {
                        axios.defaults.headers.common['Authorization'] = "Token " + localStorage.getItem('Token');
                    }
                    let response = await axios.get(urls['account']);
                    let data = response.data;
                    context.commit('setUser', data);
                    set({user_id: context.state.id});
                    resolve();
                } catch (error) {
                    console.log("Obtaining user information failed");
                    console.log(error);
                    resolve();
                }
            });
        },
        logout: (context) => new Promise(async (resolve, reject) => {
            try {
                event('logout', {event_category: 'Account'});
                set({user_id: null});
                context.commit('resetUser');
                await axios.post(urls['logout']);
                localStorage.removeItem('Token');
                resolve();
            } catch (error) {
                resolve();
            }
        }),
        async getTwoFactorDevices(context) {
            try {
                let response = await axios.get(urls['two_factor_device']);
                let data = response.data;
                context.commit('setTwoFactorDevices', data);
            } catch (error) {
                console.log("Obtaining user's devices failed");
                console.log(error);
            }
        },
        async removeTwoFactorDevice(context, deviceId) {
            try {
                let response = await axios.delete(urls['two_factor_device'] + deviceId);
                let errors = response.data['Errors'] || [];
                if (errors.length) {
                    console.log("Remove device failed");
                    console.log(response.data);
                    return;
                }
                context.dispatch('getTwoFactorDevices');
            } catch (error) {
                console.log("Remove device failed");
                console.log(error);
            }
        },
    },
    getters: {
        isLoggedIn: state => {
            return Boolean(state.username) && state.hasTwoFactorDevices;
        }
    }
}